import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectAlbumState = (state: RootState) => state.Album || initialState

export const albumSelector = createSelector([selectAlbumState], Album => Album)
